import { Component, inject } from '@angular/core';
import { Upload } from '../../../core/models/upload.model';
import { CuratedSpecialtiesService } from '../../../core/services/curated-specialties.service';
import { NavigationService } from '../../../core/services/navigation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { FormsModule } from '@angular/forms';

import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

const emptyForm = { file: null };

@Component({
    selector: 'app-capture-admin-import-curated-specialties',
    templateUrl: './capture-admin-import-curated-specialties.component.html',
    styleUrls: ['./capture-admin-import-curated-specialties.component.scss'],
    imports: [ImportNavComponent, FormsModule, FileUploadComponent, FaIconComponent]
})
export class CaptureAdminImportCuratedSpecialtiesComponent {
  private curatedSpecialtiesService = inject(CuratedSpecialtiesService);
  private navigationService = inject(NavigationService);

  uploading = false;
  formModel = { ...emptyForm };
  errors: string[] = [];

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadComplete(upload: Upload) {
    this.curatedSpecialtiesService.create(upload.signedId).subscribe(
      () => {
        this.navigationService.navigateTo('/capture-admin/tools/curated-specialties/history');
        this.uploading = false;
        this.reset();
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError(_$event) {
    this.reset();
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  private reset() {
    this.uploading = false;
    this.formModel = { ...emptyForm };
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
